import styled from 'styled-components';
import { themeSizes } from '../../styles/globalStyleVars';

export const ButtonRow = styled.div<{
  $rowAlign?: 'center' | 'start' | null;
  $noMargin?: boolean;
  $customMargin?: string;
  $stack?: boolean;
}>`
  display: flex;
  justify-content: ${({ $rowAlign }) => $rowAlign ?? 'space-between'};
  column-gap: ${({ $rowAlign }) =>
    $rowAlign === 'center' ? themeSizes.smMd : 'unset'};
  row-gap: ${themeSizes.smMd};
  align-items: center;
  margin-bottom: ${({ $customMargin, $noMargin }) =>
    $noMargin ? '0px' : $customMargin ? $customMargin : themeSizes.xl};
  ${({ $stack }) =>
    $stack ? 'flex-direction: column' : 'flex-direction: unset'};
  flex-wrap: wrap;
`;
